import { CLASSIFICATION_TYPE, PAGE_TYPE } from "../../../constants";
import { eventTrackPayloadCreator } from "../../../helpers/eventPayloadCreator";
import { EventData } from "../../../types";
import { TokenTransferEventPayload } from "./types";

const AnalyticsEventData: EventData = {
  pageDetail: "",
  pageType: PAGE_TYPE.tokenTransfer,
  eventName: "Begin Transfer Clicked",
  classification: CLASSIFICATION_TYPE.experienceEvent,
};

export const createBeginTransferClickedTrackEventPayload =
  eventTrackPayloadCreator<TokenTransferEventPayload>(AnalyticsEventData);
